import { render, staticRenderFns } from "./employeesFrrStg.vue?vue&type=template&id=504156ab&"
import script from "./employeesFrrStg.vue?vue&type=script&lang=js&"
export * from "./employeesFrrStg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports